import React, { useEffect, useRef, useState } from 'react';
import governance2 from '../../../../assets/shapes_svg/output/governance2.svg';
import { getHighlight } from '../../../../apis/Ambition';
import { fontReport } from '../../../../apis/util';
import { PRINT_WIDTH } from '..';

export const OurCompanyStructure = () => {
  const [text1, setText1] = useState();
  const [text2, setText2] = useState();

  const [question1, setQuestion1] = useState();
  const [question2, setQuestion2] = useState();

  useEffect(() => {
    handleGet();
  }, []);

  const handleGet = () => {
    getHighlight({ key: "concernrelation", setValue: setText1 });
    getHighlight({ key: "businessmanagement", setValue: setText2 });

    getHighlight({ key: "concernrelation_question", setValue: setQuestion1 });
    getHighlight({ key: "businessmanagement_question", setValue: setQuestion2 });
  };
  const ref = useRef();
  const [width,setWidth] = useState(0)
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setWidth(ref.current.clientWidth)
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);
  return (
    <div className="ourenvironmentalaim" ref={ref}>
      <div className="ourenvironmentalaim__title">
        <h4 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.7/PRINT_WIDTH,"rem") }}>Our Company Structure</h4>
        <img src={governance2} alt="" />
      </div>
      <div className="environmentalaim__body ">
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.4/PRINT_WIDTH,"rem") }}>{question1 + "\n" + text1 +
          "\n\n" +
          question2 + "\n" + text2}</h5>
      </div>
    </div>
  );
};
